import { Component, OnInit, ElementRef, ViewChild, Inject, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-dashboard-turns-waiting-time-zoom-card',
  templateUrl: './dashboard-turns-waiting-time-zoom-card.component.html',
  styleUrls: ['./dashboard-turns-waiting-time-zoom-card.component.scss']
})
export class DashboardTurnsWaitingTimeZoomCardComponent implements OnInit, AfterViewInit {

  @ViewChild('waitingTime', { static: false }) waitingTimeRef: ElementRef;
  ctx;
  myChart;
  title;
  colors;

  constructor(@Inject(MAT_DIALOG_DATA) public data,
              private dialogRef: MatDialogRef<MatDialog>) { }

  ngOnInit() {
    this.title = this.data.title;
    this.colors = this.data.colors;
  }

  ngAfterViewInit() {
    this.ctx = this.waitingTimeRef.nativeElement.getContext('2d');
    this.renderChart(this.data.data);
  }

  public close() {
    this.dialogRef.close();
  }

  private renderChart(data) {
    if (this.myChart) {
      this.myChart.destroy();
    }
    const dataSets = new Array();
    data.forEach((desk, i) => {
      dataSets.push({
        label: desk.deskName,
        data: desk.minutes,
        borderColor: this.colors[i],
        fill: false,
        borderWidth: 2,
        lineTension: 0.00
      });
    });
    this.ctx = this.waitingTimeRef.nativeElement.getContext('2d');
    this.myChart = new Chart(this.ctx, {
      type: 'line',
      data: {
        datasets: dataSets,
        labels: ['0h', '1h', '2h', '3h', '4h', '5h', '6h', '7h', '8h', '9h', '10h', '11h', '12h', '13h', '14h', '15h', '16h', '17h', '18h', '19h', '20h', '21h', '22h', '23h']
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
          align: 'end',
          fontColor: '#aaaaaa',
          labels: {
            padding: 15,
            boxWidth: 20,
            fontColor: '#aaaaaa'
          }
        },
        scales: {
          yAxes: [{
            gridLines: {
              display: true,
              color: '#eeeeee',
              drawBorder: false
            },
            ticks: {
              padding: 20,
              fontColor: '#aaaaaa',
              beginAtZero: true,
              callback: function(value, index, values) {
                if (value === 0) {
                  return value;
                } else if (value < 1) {
                  return ((value * 60) % 1) === 0 ? (value * 60) + 's' : (value * 60).toFixed(2) + 's';
                } else if (value < 60) {
                  return value + 'm';
                }
                return Math.floor(value / 60) + 'h ' + Math.floor((value % 60)) + 'm';
              }
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              fontColor: '#aaaaaa'
            }
          }]
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: (t, chartData) => {
              if (t.yLabel !== 0) {
                const h = Math.floor(t.yLabel / 60);
                const m = Math.floor((t.yLabel - (h * 60)));
                const s = Math.floor((t.yLabel - (h * 60) - m) * 60);
                return chartData.datasets[t.datasetIndex].label + ' · ' + (h !== 0 ? h + 'h ' : '') + (m !== 0 ? m + 'm ' : '') + (s !== 0 ? s + 's' : '');
              }
              return chartData.datasets[t.datasetIndex].label + ' · ' + 0;
            }
          }
        }
      },
      plugins: [{
        id: 'total',
        afterDraw: (chart) => {
          if (data.length === 0) {
            const width = chart.width;
            const height = chart.height;
            const ctx = chart.ctx;
            ctx.restore();
            const text1 = 'Not found';
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(width / 2 - ctx.measureText(text1).width / 2 - 30, height / 2 - 65, ctx.measureText(text1).width + 60, 50);
            ctx.fillStyle = '#aaaaaa';
            ctx.font = '14px sans-serif';
            ctx.fillText(text1, width / 2 - (ctx.measureText(text1).width / 2), height / 2 - 40);
            ctx.save();
          }
        }
      }]
    });
  }
}
